// src/pages/privacidad/condiciones-de-compra.js
// import Seo from "@components/common/Seo";
// import SmallBanner from "@components/common/SmallBanner";
import Text from "@components/common/Text";
import Title from "@components/common/Title";
import Layout from "@components/layouts/Layout";
import HeroSection from "@components/newVersion/HeroSection";
import React from "react";

export default function Index() {
    return (
        <>
            <Layout seo={{ title: "Condiciones de compra" }} mode="fixed">
                <HeroSection
                    filename={"bgs/bgPrivacy"}
                    firstTitle={"Condiciones de compra"}
                    secondTitle={""}
                    thirdTitle={""}
                    showScrollDownIcon={true}
                />

                <div className="container py-20 lg:px-0">
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Condiciones generales de compra
                        </Title>
                        <Text className="text-justify">
                            A continuación, te facilitamos las{" "}
                            <strong>condiciones generales de compra</strong> de
                            nuestros artículos o cursos, para que conozcas cómo
                            podrás adquirirlos y cuáles son tus derechos como
                            consumidor.
                            <br />
                            <br />
                            Estas condiciones resultarán de aplicación a las
                            compras que realices a través de las páginas web
                            localizables bajo el dominio{" "}
                            <strong>&quot;iopos.es&quot;</strong> ({" "}
                            <em>&quot;El Sitio Web&quot;</em>) titularidad de{" "}
                            <strong>&quot;iOPOS, SL&quot;</strong> ({" "}
                            <strong>&quot;iOpos&quot;</strong>), siendo
                            necesario que las <strong>aceptes</strong> cuando
                            realices cada pedido, marcando la casilla que te
                            mostramos al efecto antes de abonar tu compra.
                        </Text>
                    </div>

                    <div className="privacidad mb-10">
                        <Title className="text-left">Nuestros productos</Title>
                        <Text className="text-justify">
                            <ul className="ml-5 list-decimal">
                                <li>
                                    <strong>Características:</strong> Todos los
                                    artículos o cursos que puedes comprar a
                                    través del Sitio Web se encuentran
                                    identificados mediante la imagen de su{" "}
                                    <strong>portada</strong>, un{" "}
                                    <strong>nombre</strong> y una{" "}
                                    <strong>descripción resumida</strong> de su
                                    contenido más relevante.
                                </li>
                                <li>
                                    <strong>Disponibilidad:</strong> El número
                                    de unidades de venta por producto o plazas
                                    disponibles, en caso que sea un curso, se
                                    mantiene <strong>actualizado</strong> en el
                                    Sitio Web, según disponibilidad. Por ello,
                                    cuando no dispongamos de algún artículo de
                                    manera puntual, te lo indicaremos junto a
                                    dicho producto. Ídem en el caso de los
                                    cursos. Si, por el contrario, nos quedásemos
                                    sin existencias del mismo, lo retiraríamos
                                    del Sitio Web o{" "}
                                    <strong>bloquearíamos la compra</strong>.
                                    <br />
                                    <br />
                                    En todo caso, si casual y excepcionalmente,
                                    el Sitio Web anunciase la disponibilidad de
                                    algún producto del que no hubiera stock por
                                    causas inevitables o de fuerza mayor{" "}
                                    <em>
                                        -errores humanos o incidencias en el
                                        sistema informático-
                                    </em>{" "}
                                    y, en tales circunstancias, el sistema te
                                    permitiese comprarlo (pagarlo), te pedimos
                                    encarecidamente disculpas. En ese caso, tan
                                    pronto como tengamos constancia de tu
                                    pedido, te informaremos de lo sucedido y
                                    procederemos a reembolsarte el importe que
                                    hayas abonado en un plazo máximo de{" "}
                                    <strong>72 horas</strong>.
                                </li>
                            </ul>
                        </Text>
                    </div>

                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Precios. Gastos de envío
                        </Title>
                        <Text className="text-justify">
                            <ul className="ml-5 list-disc">
                                <li>
                                    El precio de los productos o cursos
                                    ofrecidos a través del Sitio Web incluye el{" "}
                                    <strong>I.V.A. correspondiente</strong>.
                                </li>
                                <li>
                                    En cuanto a los{" "}
                                    <strong>gastos de envío</strong> que llevará
                                    aparejada tu compra, podrás identificarlos
                                    fácilmente acudiendo al &quot;carro de la
                                    compra&quot; que localizarás en el margen
                                    superior derecho del Sitio Web (icono
                                    carrito). Allí constarán debidamente
                                    identificados, de forma separada al precio
                                    de tu producto (<em>impuestos incluidos</em>
                                    ).
                                </li>
                                <li>
                                    Los gastos de envío se determinarán en
                                    función del número de artículos que
                                    selecciones para su compra. En todo caso,
                                    como te indicamos en el apartado{" "}
                                    <strong>
                                        &lsquo;PROCESO DE COMPRA&apos;
                                    </strong>
                                    , existirá un <strong>límite máximo</strong>{" "}
                                    por gastos de envío que conocerás antes de
                                    proceder al abono de tu compra.
                                </li>
                                <li>
                                    Puede que haya{" "}
                                    <strong>portes gratis</strong> en
                                    promociones concretas, en cuyo caso te lo
                                    especificaremos.
                                </li>
                            </ul>

                            <p className="mt-5 font-semibold text-cpurple">
                                Si el pedido es devuelto debido a que la
                                dirección proporcionada por el cliente es{" "}
                                <strong>incorrecta o está incompleta</strong>,
                                los gastos del nuevo envío correrán por cuenta
                                del cliente, los mismos que pagará en el momento
                                de la compra inicial. Te recomendamos verificar
                                cuidadosamente tus datos de envío antes de
                                confirmar la compra para evitar contratiempos.
                            </p>
                        </Text>
                    </div>

                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Pedidos no recogidos
                        </Title>
                        <Text className="text-justify">
                            <p>
                                En caso de que un pedido sea devuelto a nuestro
                                almacén porque{" "}
                                <strong className="text-cpurple">
                                    el comprador no lo ha recogido en el plazo
                                    indicado por la empresa de mensajería
                                </strong>
                                , se aplicarán las siguientes condiciones:
                            </p>

                            <ul className="ml-5 list-disc">
                                <li>
                                    <strong className="text-cpurple">
                                        No se realizará ningún reembolso
                                    </strong>{" "}
                                    del importe del producto ni de los gastos de
                                    envío.
                                </li>
                                <li>
                                    Si el cliente desea que el pedido le sea
                                    enviado nuevamente,{" "}
                                    <strong className="text-cpurple">
                                        deberá abonar los gastos de un nuevo
                                        envío
                                    </strong>
                                    .
                                </li>
                                <li>
                                    El reenvío se gestionará una vez recibido el{" "}
                                    <strong>pago</strong> y confirmada la
                                    dirección de entrega.
                                </li>
                            </ul>
                        </Text>
                    </div>

                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Territorio de entrega
                        </Title>
                        <Text className="text-justify">
                            Los productos ofrecidos a través del Sitio Web{" "}
                            <strong>no se venden fuera de España</strong>. Ello
                            implica que nuestros pedidos podrán ser entregados
                            en cualquier lugar de la <strong>península</strong>,{" "}
                            <strong>Islas Canarias</strong>,{" "}
                            <strong>Islas Baleares</strong>,{" "}
                            <strong>Ceuta</strong> y <strong>Melilla</strong>.
                        </Text>
                    </div>

                    <div className="privacidad mb-10">
                        <Title className="text-left">Formas de pago</Title>
                        <Text className="text-justify">
                            <ul className="ml-5 list-disc">
                                <li>
                                    Las compras realizadas a través del Sitio
                                    web podrán abonarse mediante{" "}
                                    <strong>PayPal</strong> o bien a través de{" "}
                                    <strong>tarjeta de débito o crédito</strong>{" "}
                                    (siempre mediante la pasarela de PayPal).
                                </li>
                                <li>
                                    En todo caso, ten en cuenta que{" "}
                                    <strong>iOpos no admite</strong> el pago a
                                    través de{" "}
                                    <strong>domiciliación bancaria</strong>,{" "}
                                    <strong>contra reembolso</strong> ni métodos
                                    similares.
                                </li>
                            </ul>
                        </Text>
                    </div>

                    <div className="privacidad mb-10">
                        <Title className="text-left">Proceso de compra</Title>
                        <Text className="space-y-2 text-justify">
                            Hacer un pedido en el Sitio Web resulta muy sencillo
                            y te lo explicamos a continuación.
                            <br />
                            <br />
                            En todo caso, si tienes alguna cuestión al respecto,
                            por favor, no dudes en contactar con nosotros a
                            través de alguno de los medios que ponemos a tu
                            disposición en el apartado{" "}
                            <strong>&quot;CONTACTO&quot;</strong>.
                        </Text>
                        <ul className="ml-5 mt-5 list-decimal space-y-5">
                            <li>
                                <strong>Compara y elige</strong>
                                <br />
                                Dirígete a cualquiera de las secciones que
                                localizarás en el Sitio Web, de acuerdo con tus
                                preferencias, y escoge la sección que te
                                interese.
                                <br />
                                Hecho esto, te mostraremos los artículos
                                disponibles para esa sección. Podrás consultar,
                                entonces, el resumen de contenidos del producto
                                o curso que te interese.
                            </li>
                            <li>
                                <strong>Añádelo al carro de compra</strong>
                                <br />
                                Cuando hayas localizado el/los artículo/s de tu
                                interés, indica si deseas uno o más (haciendo
                                clic en el botón de añadir al carro) y pulsa el
                                botón{" "}
                                <strong>
                                    &apos;AÑADIR A LA CESTA&apos;
                                </strong>{" "}
                                para que pueda añadirse a tu{" "}
                                <strong>&lsquo;CESTA DE LA COMPRA&apos;</strong>
                                . En todo caso, ten en cuenta que este gesto aún{" "}
                                <em>no implica</em> que hayas formalizado tu
                                pedido, para lo que será necesario que aceptes
                                las presentes condiciones y, posteriormente,
                                efectúes el abono de dicho pedido cuando te lo
                                indiquemos.
                                <br />
                                Una vez seleccionados todos los artículos que
                                deseas comprar, dirígete a la{" "}
                                <strong>
                                    &lsquo;CESTA DE LA COMPRA&apos;
                                </strong>{" "}
                                y clica en{" "}
                                <strong>&lsquo;REALIZAR PAGO&apos;</strong>.
                                Tras ello, te mostraremos un resumen de tu
                                pedido con el total del pedido y los gastos de
                                envío (<strong>IVA incluido</strong>).
                            </li>
                            <li>
                                <strong>Introduce tus datos personales</strong>
                                <br />
                                Seguidamente, te encontrarás cuatro pequeños
                                campos en los que has de rellenar tus datos
                                personales: tu <strong>nombre</strong>, el{" "}
                                <strong>teléfono de contacto</strong>, tu{" "}
                                <strong>correo electrónico</strong> y la{" "}
                                <strong>dirección de envío</strong> (en caso que
                                sea necesaria).
                                <br />
                                <br />
                                <strong className="text-cpurple">
                                    Facturación (Veri*factu)
                                </strong>
                                <br />
                                En iOpos emitimos factura en todas las compras y
                                la registramos mediante un sistema adaptado a{" "}
                                <strong>Veri*factu (AEAT)</strong>.
                                <br />
                                <br />
                                Si quieres que la factura sea{" "}
                                <strong>nominativa</strong> (a tu nombre), es
                                necesario indicar tu{" "}
                                <strong>DNI/NIF/NIE</strong> para poder emitirla
                                y enviarla correctamente.
                                <br />
                                <br />
                                Si prefieres no facilitarlo, emitiremos
                                igualmente la factura, pero será{" "}
                                <strong>no nominativa / simplificada</strong> (
                                <em>
                                    no válida para deducciones ni para acreditar
                                    datos fiscales a tu nombre
                                </em>
                                ).
                                <br />
                                <br />
                                Tu DNI/NIF se utiliza{" "}
                                <strong>únicamente</strong> para la emisión de
                                la factura y cumplimiento legal. No se usa con
                                fines comerciales.
                                <br />
                                <br />
                                Una vez introducidos, puedes marcar &quot;el
                                checkbox&quot; y hacer clic en el botón{" "}
                                <strong>&quot;REALIZAR PAGO&quot;</strong>.
                            </li>
                            <li>
                                <strong>Realizar Pago</strong>
                                <br />
                                Para realizar el pago tendrás que hacer clic en
                                el botón correspondiente al{" "}
                                <strong>método de pago disponible</strong> y
                                luego introducir tus credenciales. Si todo ha
                                ido bien, recibirás un mensaje en pantalla
                                indicando que todo ha sido correcto y además un
                                correo electrónico con el{" "}
                                <strong>resumen de la compra</strong>. Si no
                                recibes el correo en unos minutos, puedes mirar
                                en &quot;Correo No Deseado&quot;.
                            </li>
                        </ul>
                    </div>

                    {/** Devoluciones. Cancelación del Pedido e Incidencias – Módulos de aplicaciones */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Devoluciones. Cancelación del Pedido e Incidencias -
                            Módulos de aplicaciones
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                Los módulos de aplicaciones de iOpos son
                                productos digitales de{" "}
                                <strong>acceso inmediato</strong> y{" "}
                                <strong>uso interactivo</strong>, cuyo consumo
                                puede medirse objetivamente mediante la
                                realización de tests. Debido a la naturaleza de
                                estos productos, el usuario podrá solicitar la
                                devolución del importe abonado siempre que no
                                hayan transcurrido más de{" "}
                                <strong>14 días naturales</strong> desde la
                                fecha de compra y que el uso del módulo no
                                supere la realización de{" "}
                                <strong>15 tests</strong>.
                            </p>

                            <p>
                                <strong>Qué cuenta como uso:</strong> a efectos
                                de esta política, se considera uso del producto
                                cada test iniciado o realizado dentro de la
                                aplicación, con independencia de que se haya
                                finalizado o no. Una vez superado cualquiera de
                                los dos límites indicados, el plazo temporal o
                                el número máximo de tests,{" "}
                                <strong>no se admitirán devoluciones</strong>.
                            </p>

                            <p>
                                <strong>Podcasts de la aplicación:</strong> los
                                podcasts disponibles dentro de la aplicación
                                tienen la consideración de contenido digital de
                                acceso inmediato. El usuario podrá solicitar la
                                devolución del importe abonado siempre que no
                                hayan transcurrido más de{" "}
                                <strong>5 días naturales</strong> desde la fecha
                                de compra. Transcurrido dicho plazo, no se
                                admitirán devoluciones.
                            </p>

                            <p>
                                <strong>Incidencia técnica:</strong> en caso de
                                que el usuario detecte una incidencia técnica
                                que impida el correcto acceso o funcionamiento
                                del módulo de aplicaciones o podcast, deberá
                                comunicarlo a la mayor brevedad posible y, en
                                todo caso, dentro de un plazo máximo de{" "}
                                <strong>4 días naturales</strong> desde la
                                compra. Una vez verificada la incidencia, iOpos
                                podrá proceder a la resolución del problema, a
                                la corrección del acceso o, si procede, a la
                                devolución del importe correspondiente.
                            </p>

                            <p>
                                <strong>Cancelación:</strong> la cancelación del
                                pedido únicamente será posible si el módulo de
                                aplicaciones y/o podcast{" "}
                                <strong>
                                    no ha sido activado ni utilizado
                                </strong>
                                . Una vez activado el acceso al producto, se
                                considerará iniciado el servicio.
                            </p>

                            <p>
                                <strong>Ámbito de aplicación:</strong> esta
                                política de devoluciones es aplicable
                                exclusivamente a los módulos de aplicaciones
                                (test) y a los podcasts, y no resulta de
                                aplicación a otros productos digitales de iOpos,
                                tales como cursos online, planes de suscripción
                                o simulacros de entrevista, que se rigen por sus
                                propias condiciones específicas.
                            </p>
                        </Text>
                    </div>

                    {/** Devoluciones. Cancelación del Pedido e Incidencias – Cursos online */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Devoluciones. Cancelación del Pedido e Incidencias –
                            Cursos online
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                Los cursos online ofrecidos por iOpos
                                constituyen{" "}
                                <strong>productos digitales formativos</strong>{" "}
                                que incluyen el acceso a contenidos
                                audiovisuales, clases grabadas o en directo,{" "}
                                <strong>materiales descargables</strong>,
                                recursos académicos y, en algunos casos,
                                planificación y acompañamiento docente. El
                                acceso a estos contenidos se habilita de forma{" "}
                                <strong>inmediata</strong> tras la compra, lo
                                que implica el{" "}
                                <strong>inicio automático</strong> de la
                                prestación del servicio digital.
                            </p>

                            <p>
                                <strong>
                                    Renovación del acceso a cursos online:
                                </strong>{" "}
                                en aquellos cursos online que dispongan de un
                                periodo de acceso limitado en el campus iOpos y
                                permitan su renovación mediante una nueva
                                compra, el alumno deberá comunicar dicha
                                adquisición a través del correo electrónico{" "}
                                <a href="mailto:info@iopos.es">
                                    <strong>info@iopos.es</strong>
                                </a>
                                , solicitando la activación manual de la
                                renovación. La renovación del acceso{" "}
                                <strong>
                                    no se realizará de forma automática
                                </strong>
                                , por lo que será responsabilidad del alumno
                                notificar la nueva compra para que iOpos pueda
                                gestionar correctamente la ampliación del
                                periodo de acceso correspondiente.
                            </p>

                            <p>
                                <strong>Plazo de devolución:</strong> la
                                devolución de un curso online podrá solicitarse
                                únicamente dentro de los{" "}
                                <strong>5 días naturales</strong> posteriores a
                                la fecha de compra. Transcurrido dicho plazo,{" "}
                                <strong>no se admitirán devoluciones</strong>,
                                con independencia del grado de uso o
                                visualización que el usuario haya realizado del
                                contenido. Una vez iniciado el acceso al curso,
                                se considera que el servicio ha comenzado a
                                prestarse.
                            </p>

                            <p>
                                <strong>Acceso activado e incidencias:</strong>{" "}
                                no será posible solicitar la devolución del
                                curso cuando el acceso a los contenidos ya haya
                                sido activado y utilizado, salvo en aquellos
                                casos en los que exista una{" "}
                                <strong>incidencia técnica</strong> imputable a
                                iOpos que impida de forma efectiva el acceso o
                                el uso del curso. En caso de incidencia, el
                                usuario deberá comunicarlo a la mayor brevedad
                                posible y, en todo caso, dentro de un plazo
                                máximo de <strong>cuatro días naturales</strong>{" "}
                                desde la fecha de compra. Una vez verificada la
                                incidencia, iOpos procederá a corregir el acceso
                                o solucionar el problema técnico detectado y,
                                únicamente si no fuera posible su resolución,
                                podrá valorar la devolución correspondiente.
                            </p>

                            <p>
                                <strong>Material no descargable:</strong> el
                                hecho de que los materiales del curso no puedan
                                descargarse no constituye motivo de devolución.
                                Los cursos están diseñados para su{" "}
                                <strong>visualización y uso online</strong>, y
                                esta condición se especifica tanto en la
                                información previa del curso como en el apartado
                                de preguntas frecuentes, por lo que el usuario
                                acepta dicha limitación en el momento de la
                                compra.
                            </p>

                            <p>
                                <strong>Cancelación:</strong> la cancelación del
                                pedido solo será posible si el curso{" "}
                                <strong>
                                    no ha sido activado ni se ha accedido al
                                    contenido
                                </strong>
                                . Una vez habilitado el acceso al curso, se
                                considerará iniciado el servicio digital y no
                                procederá la cancelación.
                            </p>

                            <p>
                                <strong>Promociones y ofertas:</strong> estas se
                                aplican únicamente durante el periodo en el que
                                estén activas y{" "}
                                <strong>no tienen carácter retroactivo</strong>.
                                Por este motivo, si un curso ha sido adquirido y
                                posteriormente entra en promoción o descuento,
                                no será posible realizar ajustes de precio ni
                                gestionar devoluciones con el fin de volver a
                                comprar el producto aplicando dicha oferta.
                            </p>

                            <p>
                                <strong>Ámbito de aplicación:</strong> estas
                                condiciones de devolución son aplicables
                                exclusivamente a los cursos online de iOpos y no
                                resultan de aplicación a otros productos o
                                servicios, como los módulos de aplicaciones, los
                                simulacros de entrevista, los planes de
                                suscripción u otros servicios formativos, que se
                                rigen por sus condiciones específicas.
                            </p>
                        </Text>
                    </div>

                    {/** Devoluciones. Cancelación del Pedido e Incidencias – Entrevistas y simulacros de entrevista */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Devoluciones. Cancelación del Pedido e Incidencias –
                            Cursos presenciales
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                Los cursos presenciales ofrecidos por iOpos son{" "}
                                <strong>servicios formativos</strong> que
                                requieren la planificación previa de grupos,
                                profesorado, espacios físicos y recursos
                                académicos. Por este motivo, su contratación
                                implica la <strong>reserva de plaza</strong> y
                                la asignación anticipada de medios, lo que
                                condiciona su política de cancelación y
                                devolución.
                            </p>

                            <p>
                                <strong>Plazo de devolución:</strong> la
                                devolución del importe de un curso presencial
                                solo podrá solicitarse dentro de los{" "}
                                <strong>5 días naturales</strong> posteriores a
                                la fecha de compra y siempre que el curso{" "}
                                <strong>no haya comenzado</strong> ni se haya
                                asistido a ninguna sesión. Una vez iniciado el
                                curso o asistida la primera clase, se
                                considerará iniciado el servicio formativo y{" "}
                                <strong>no procederá la devolución</strong>, con
                                independencia del número de sesiones realizadas
                                o del grado de asistencia del alumno.
                            </p>

                            <p>
                                <strong>Cancelación de plaza:</strong> la
                                cancelación de la reserva de plaza únicamente
                                será posible si se solicita dentro del plazo
                                indicado y antes del comienzo del curso. En caso
                                contrario,{" "}
                                <strong>
                                    no se admitirán cancelaciones ni
                                    devoluciones
                                </strong>
                                , dado que la plaza reservada no podrá ser
                                reasignada con carácter inmediato.
                            </p>

                            <p>
                                <strong>Incidencias o cambios:</strong> en
                                aquellos casos en los que, por causas imputables
                                a iOpos, el curso presencial no pueda impartirse
                                en las condiciones anunciadas, se cancele
                                definitivamente o se produzca una modificación
                                sustancial que impida la asistencia del alumno,
                                iOpos ofrecerá una solución alternativa, como el
                                cambio de turno, grupo o modalidad, o bien la
                                devolución del importe correspondiente, según
                                proceda.
                            </p>

                            <p>
                                <strong>No asistencia:</strong> la imposibilidad
                                de asistencia por causas personales del alumno,
                                cambios de disponibilidad horaria, razones
                                laborales, académicas o de cualquier otra índole
                                ajena a iOpos{" "}
                                <strong>no dará derecho a la devolución</strong>{" "}
                                del importe abonado,{" "}
                                <strong>
                                    ni el cambio por otro tipo de formación o de
                                    fecha
                                </strong>{" "}
                                fuera de los plazos establecidos.
                            </p>

                            <p>
                                <strong>Ámbito de aplicación:</strong> estas
                                condiciones son aplicables exclusivamente a los
                                cursos presenciales y no resultan de aplicación
                                a otros productos o servicios ofrecidos por
                                iOpos, como los cursos online, los módulos de
                                aplicaciones, los simulacros de entrevista o los
                                planes de suscripción, que se rigen por sus
                                condiciones específicas.
                            </p>
                        </Text>
                    </div>

                    {/** Devoluciones. Cancelación del Pedido e Incidencias – Entrevistas y simulacros de entrevista */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Devoluciones. Cancelación del Pedido e Incidencias –
                            Entrevistas y simulacros de entrevista
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                Las entrevistas y simulacros de entrevista
                                ofrecidos por iOpos constituyen{" "}
                                <strong>servicios personalizados</strong> que
                                requieren la asignación de profesionales, la
                                reserva de agenda y, en algunos casos, la
                                preparación previa específica para cada usuario.
                                Por su naturaleza, estos servicios se prestan en
                                una <strong>fecha y hora determinadas</strong>,
                                ya sea de manera presencial u online, y su
                                contratación implica la reserva anticipada de
                                recursos humanos y técnicos.
                            </p>

                            <p>
                                <strong>Antelación mínima:</strong> la
                                devolución del importe de una entrevista o
                                simulacro solo podrá solicitarse si se comunica
                                con una antelación mínima de{" "}
                                <strong>5 días naturales</strong> respecto a la
                                fecha reservada para la realización del
                                servicio. Asimismo, dentro de ese mismo plazo,
                                el usuario podrá solicitar un{" "}
                                <strong>
                                    cambio de fecha, hora o modalidad
                                </strong>
                                , siempre que exista disponibilidad para
                                reasignar la sesión. Fuera de dicho plazo,{" "}
                                <strong>
                                    no será posible cancelar ni solicitar la
                                    devolución
                                </strong>{" "}
                                del importe abonado.
                            </p>

                            <p>
                                <strong>No asistencia:</strong> no se admitirán
                                devoluciones una vez realizada la entrevista o
                                simulacro, ni tampoco en los casos en los que el
                                usuario no se presente en la fecha y hora
                                acordadas. La imposibilidad de asistencia por
                                motivos personales, laborales, académicos o de
                                cualquier otra índole ajena a iOpos{" "}
                                <strong>no dará derecho a la devolución</strong>{" "}
                                del importe abonado.
                            </p>

                            <p>
                                <strong>Cambio de modalidad:</strong> en
                                aquellos supuestos en los que el usuario
                                solicite un cambio de modalidad o de tipo de
                                simulacro que implique una diferencia de precio,
                                podrá realizarse (dentro de la antelación mínima
                                de <strong>5 días naturales</strong>), si
                                procede, el ajuste correspondiente o la
                                devolución de la parte proporcional del importe,
                                siempre que la solicitud se efectúe dentro del
                                plazo establecido y exista disponibilidad.
                            </p>

                            <p>
                                <strong>Incidencia imputable a iOpos:</strong>{" "}
                                en el caso de que, por causas imputables a
                                iOpos, no fuera posible la realización del
                                servicio en las condiciones acordadas, se
                                ofrecerá al usuario una alternativa equivalente
                                o, en su defecto, la devolución del importe
                                correspondiente.
                            </p>

                            <p>
                                <strong>Ámbito de aplicación:</strong> estas
                                condiciones son aplicables exclusivamente a las
                                entrevistas y simulacros de entrevista y no
                                resultan de aplicación a otros productos o
                                servicios de iOpos, como los cursos online, los
                                cursos presenciales, los módulos de aplicaciones
                                o los planes de suscripción, que se rigen por
                                sus propias condiciones específicas.
                            </p>
                        </Text>
                    </div>

                    {/** Devoluciones. Cancelación del Pedido e Incidencias – Clases físicas */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Devoluciones. Cancelación del Pedido e Incidencias –
                            Clases físicas
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                Las clases físicas ofrecidas por iOpos son{" "}
                                <strong>
                                    servicios formativos presenciales
                                </strong>{" "}
                                de carácter periódico que implican la
                                organización de grupos, la asignación de
                                profesorado y la reserva de espacios físicos. La
                                contratación de este tipo de servicios conlleva
                                la{" "}
                                <strong>
                                    planificación anticipada de recursos
                                </strong>
                                , por lo que se aplican condiciones específicas
                                en materia de cambios, cancelaciones y
                                devoluciones.
                            </p>

                            <p>
                                <strong>Plazo de devolución:</strong> en el caso
                                de la compra de un pack de clases físicas, la
                                devolución del importe únicamente podrá
                                solicitarse dentro de los{" "}
                                <strong>5 días naturales</strong> posteriores a
                                la fecha de compra, siempre que el usuario{" "}
                                <strong>
                                    no haya asistido a ninguna sesión
                                </strong>
                                . Transcurrido dicho plazo o una vez iniciada la
                                asistencia a las clases, se considerará iniciado
                                el servicio y{" "}
                                <strong>
                                    no procederá la devolución total ni parcial
                                </strong>{" "}
                                del importe abonado.
                            </p>

                            <p>
                                <strong>Cambios de reserva:</strong> los cambios
                                de reserva de una sesión concreta deberán
                                solicitarse con una antelación mínima de{" "}
                                <strong>48 horas</strong> respecto a la fecha y
                                hora programadas de la clase. Las solicitudes
                                realizadas fuera de este plazo{" "}
                                <strong>no podrán ser atendidas</strong> y la
                                sesión se considerará impartida, aun cuando el
                                alumno no asista.
                            </p>

                            <p>
                                <strong>Reserva y caducidad:</strong> los
                                enlaces de reserva enviados al usuario para la
                                gestión y selección de fechas de las clases
                                físicas tendrán una validez de{" "}
                                <strong>30 días naturales</strong> desde la
                                fecha de compra del pack. Transcurrido dicho
                                plazo sin que se haya realizado la reserva
                                correspondiente, los enlaces caducarán
                                automáticamente y{" "}
                                <strong>
                                    no podrá garantizarse la disponibilidad del
                                    servicio
                                </strong>
                                , sin que ello dé lugar a la devolución del
                                importe abonado.
                            </p>

                            <p>
                                <strong>No asistencia:</strong> la inscripción
                                en las clases físicas implica la reserva de
                                plaza, por lo que la no asistencia del alumno a
                                una o varias sesiones, por motivos personales,
                                laborales, académicos o de cualquier otra índole
                                ajena a iOpos,{" "}
                                <strong>no dará derecho a la devolución</strong>{" "}
                                del importe ni a la compensación de las sesiones
                                no asistidas.
                            </p>

                            <p>
                                <strong>Incidencia imputable a iOpos:</strong>{" "}
                                en el supuesto de que, por causas imputables a
                                iOpos, una clase física no pueda impartirse en
                                las condiciones previstas, se cancele o se
                                produzca una modificación sustancial que
                                imposibilite la asistencia del alumno, iOpos
                                ofrecerá una solución alternativa equivalente o,
                                en su defecto, la reprogramación o devolución
                                proporcional correspondiente.
                            </p>

                            <p>
                                <strong>Ámbito de aplicación:</strong> estas
                                condiciones son aplicables exclusivamente a las
                                clases físicas y no resultan de aplicación a
                                otros productos o servicios de iOpos, como los
                                cursos online, los cursos presenciales, los
                                módulos de aplicaciones, las entrevistas o los
                                planes de suscripción, que se rigen por sus
                                condiciones específicas.
                            </p>
                        </Text>
                    </div>

                    {/** Devoluciones. Cancelación del Pedido e Incidencias – Libros y/o packs de libros */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Devoluciones. Cancelación del Pedido e Incidencias –
                            Libros y/o packs de libros
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                Los libros y packs de libros ofrecidos por iOpos
                                son <strong>productos físicos</strong>{" "}
                                destinados a la preparación de oposiciones y se
                                envían al domicilio indicado por el usuario en
                                el momento de la compra. Debido a la naturaleza
                                de estos productos, se aplican condiciones
                                específicas en materia de{" "}
                                <strong>
                                    cancelación, devoluciones e incidencias
                                </strong>
                                .
                            </p>

                            <p>
                                <strong>Plazo de desistimiento:</strong> el
                                cliente dispone de un plazo de{" "}
                                <strong>48 horas</strong> desde la realización
                                de la compra para comunicar su deseo de desistir
                                de la misma sin coste adicional, siempre que el
                                pedido <strong>no haya sido enviado</strong>.
                                Para ello, deberá contactar con iOpos a través
                                del correo electrónico{" "}
                                <a
                                    className="link"
                                    href="mailto:info@iopos.academy"
                                >
                                    info@iopos.academy
                                </a>
                                . Una vez que el pedido haya sido enviado,{" "}
                                <strong>no será posible la cancelación</strong>{" "}
                                sin aplicar las condiciones de devolución
                                indicadas a continuación.
                            </p>

                            <p>
                                <strong>Condiciones de devolución:</strong>{" "}
                                transcurrido el plazo inicial de{" "}
                                <strong>48 horas</strong>, el cliente podrá
                                desistir de la compra bajo las siguientes
                                condiciones:
                            </p>

                            <ul className="mb-5 ml-5 list-disc">
                                <li>
                                    El envío de devolución será{" "}
                                    <strong>preregistrado</strong> por el equipo
                                    de iOpos para que quede correctamente
                                    vinculado al envío original, y se remitirá
                                    al cliente la información necesaria para que
                                    realice la admisión del envío de vuelta.
                                </li>
                                <li>
                                    El coste del envío de devolución correrá a{" "}
                                    <strong>cargo del cliente</strong> y será
                                    descontado del importe a reembolsar.
                                </li>
                            </ul>

                            <p>
                                <strong>Estado del producto:</strong> una vez
                                recibido el libro o pack de libros en el almacén
                                de iOpos, se comprobará que el producto se
                                encuentra en <strong>perfecto estado</strong>,
                                sin señales de uso, manipulación ni daños. En
                                caso de que el estado del producto sea conforme,
                                se procederá al reembolso del importe
                                correspondiente únicamente al producto,
                                descontando el coste del envío de devolución. En
                                ningún caso se reembolsarán los gastos de envío
                                originales ni los gastos del envío de vuelta.
                            </p>

                            <p>
                                <strong>No admisión:</strong> no se admitirán
                                devoluciones si el producto presenta signos de
                                uso, manipulación indebida o deterioro derivado
                                de una incorrecta conservación. Asimismo, no se
                                aceptarán devoluciones cuando el daño sea
                                consecuencia del desgaste normal tras la
                                recepción del producto. Se recomienda al cliente
                                conservar el embalaje original, retirar las
                                etiquetas del envío original y no manipular el
                                contenido antes de proceder a su devolución.
                            </p>

                            <p>
                                <strong>Incidencia por transporte:</strong> en
                                caso de error en el pedido o de que el libro
                                recibido presente daños derivados del
                                transporte, el cliente deberá comunicar la
                                incidencia en un plazo máximo de{" "}
                                <strong>cuatro días naturales</strong> desde la
                                recepción del pedido. Una vez verificada la
                                incidencia, iOpos procederá al envío del
                                producto correcto, a la sustitución del libro
                                dañado o a la resolución de la incidencia
                                correspondiente, sin coste adicional para el
                                cliente.
                            </p>

                            <p>
                                <strong>Ámbito de aplicación:</strong> estas
                                condiciones son aplicables exclusivamente a los
                                libros y packs de libros y no resultan de
                                aplicación a otros productos o servicios
                                ofrecidos por iOpos, que se rigen por sus
                                propias condiciones específicas.
                            </p>
                        </Text>
                    </div>

                    {/** Devoluciones. Cancelación del Pedido e Incidencias – Cursos de formación policial */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Devoluciones. Cancelación del Pedido e Incidencias –
                            Cursos de formación policial
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                Los cursos de formación policial ofrecidos por
                                iOpos son{" "}
                                <strong>
                                    programas formativos especializados
                                </strong>{" "}
                                dirigidos a la preparación de procesos
                                selectivos vinculados a cuerpos policiales y de
                                seguridad. Estos cursos pueden incluir
                                contenidos completos de formación, acceso a
                                materiales digitales, sesiones presenciales u
                                online, planificación académica y recursos
                                específicos adaptados a cada convocatoria. La
                                contratación de estos cursos implica la
                                asignación de plazas, profesorado y recursos
                                formativos.
                            </p>

                            <p>
                                <strong>Plazo de devolución:</strong> la
                                devolución del importe de un curso de formación
                                policial únicamente podrá solicitarse dentro de
                                los <strong>5 días naturales</strong>{" "}
                                posteriores a la fecha de compra, siempre que el
                                curso <strong>no haya comenzado</strong> y el
                                alumno no haya accedido a los contenidos
                                formativos ni participado en ninguna sesión.
                                Transcurrido dicho plazo o una vez iniciado el
                                curso, se considerará comenzada la prestación
                                del servicio formativo y{" "}
                                <strong>
                                    no procederá la devolución total ni parcial
                                </strong>{" "}
                                del importe abonado, con independencia del grado
                                de asistencia o uso realizado.
                            </p>

                            <p>
                                <strong>No admisión por motivos ajenos:</strong>{" "}
                                no se admitirán devoluciones por motivos
                                relacionados con cambios de disponibilidad del
                                alumno, incompatibilidad horaria, decisiones
                                personales, expectativas sobre el contenido del
                                curso o por la imposibilidad de descargar los
                                materiales formativos, dado que el acceso,
                                formato y condiciones de uso de los contenidos
                                se detallan previamente tanto en la información
                                del curso como en el apartado de preguntas
                                frecuentes.
                            </p>

                            <p>
                                <strong>Incidencia técnica:</strong> en caso de
                                que exista una incidencia técnica imputable a
                                iOpos que impida de forma efectiva el acceso a
                                los contenidos o la correcta prestación del
                                curso, el alumno deberá comunicarlo en un plazo
                                máximo de <strong>4 días naturales</strong>{" "}
                                desde la fecha de compra o desde que se produzca
                                la incidencia. Una vez verificada, iOpos
                                procederá a solucionar el problema técnico y,
                                únicamente si no fuera posible su resolución,
                                podrá valorar la devolución correspondiente o la
                                aplicación de una alternativa formativa
                                equivalente.
                            </p>

                            <p>
                                <strong>Cancelación:</strong> la cancelación del
                                pedido solo será posible si el curso{" "}
                                <strong>
                                    no ha sido activado ni se ha iniciado
                                </strong>{" "}
                                la prestación del servicio. Una vez habilitado
                                el acceso a los contenidos o iniciado el curso,{" "}
                                <strong>no procederá la cancelación</strong>.
                            </p>

                            <p>
                                <strong>Promociones y descuentos:</strong> las
                                promociones, descuentos u ofertas aplicables a
                                los cursos de formación policial tendrán validez
                                exclusivamente durante el periodo en el que
                                estén activas y{" "}
                                <strong>no tendrán carácter retroactivo</strong>
                                . En consecuencia, no se realizarán devoluciones
                                ni ajustes de precio cuando un curso haya sido
                                adquirido y posteriormente entre en promoción.
                            </p>

                            <p>
                                <strong>Ámbito de aplicación:</strong> estas
                                condiciones son aplicables exclusivamente a los
                                cursos de formación policial y no resultan de
                                aplicación a otros productos o servicios
                                ofrecidos por iOpos, como los cursos online
                                generales, cursos presenciales, clases físicas,
                                módulos de aplicaciones, entrevistas o planes de
                                suscripción, que se rigen por sus condiciones
                                específicas.
                            </p>
                        </Text>
                    </div>

                    {/** Devoluciones. Cancelación del Pedido e Incidencias – Tests de diagnóstico y tests oficiales */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Devoluciones. Cancelación del Pedido e Incidencias –
                            Tests de diagnóstico y tests oficiales
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                Los <strong>tests de diagnóstico</strong>,
                                <strong>tests oficiales</strong> y demás
                                herramientas de evaluación ofrecidos por iOpos
                                tienen como finalidad orientar al aspirante
                                sobre su nivel de preparación y facilitar el
                                entrenamiento de las distintas fases del proceso
                                selectivo. Su contratación constituye un{" "}
                                <strong>
                                    servicio formativo digital y/o presencial
                                </strong>
                                , según la modalidad del producto adquirido.
                            </p>

                            <p>
                                Salvo que en la ficha del producto se indique
                                expresamente lo contrario, la adquisición de un
                                test no conlleva ningún{" "}
                                <strong>derecho de devolución</strong> una vez
                                el acceso haya sido activado o el test haya sido
                                realizado, al considerarse iniciado el servicio.
                            </p>

                            <p>
                                La devolución de un test únicamente podrá
                                solicitarse dentro de los{" "}
                                <strong>
                                    5 días naturales posteriores a la fecha de
                                    compra
                                </strong>
                                , siempre que{" "}
                                <strong>
                                    no se haya asistido a la sesión formativa
                                    asociada al producto, no se haya realizado
                                    el test y no se haya activado o utilizado el
                                    acceso a sus contenidos
                                </strong>
                                , cuando corresponda. Una vez se haya asistido a
                                la clase, realizado el test o iniciado el acceso
                                al contenido, se entenderá iniciado el servicio
                                y no procederá la devolución.
                            </p>

                            <p>
                                Determinados tests podrán incluir una
                                <strong>garantía comercial específica</strong>,
                                cuyas condiciones se describirán en la propia
                                ficha del producto. En estos casos, dicha
                                garantía tendrá exclusivamente el alcance y las
                                limitaciones expresamente indicadas, sin que
                                pueda interpretarse de forma extensiva.
                            </p>

                            <p>
                                En particular, cuando la garantía comercial
                                establezca la devolución de un porcentaje del
                                importe en caso de no superar una determinada
                                fase del proceso selectivo, esta se entenderá
                                aplicable únicamente en los supuestos
                                expresamente previstos en el producto y{" "}
                                <strong>
                                    nunca una vez el aspirante haya accedido a
                                    la fase para cuya preparación fue adquirido
                                    el test
                                </strong>
                                , aunque el resultado final de dicha fase sea de{" "}
                                <strong>APTO</strong> o <strong>NO APTO</strong>
                                .
                            </p>

                            <p>
                                En el caso del{" "}
                                <strong>
                                    Curs Preparació Tercera Prova Mossos
                                    d&apos;Esquadra (Test Oficial de Diagnosi de
                                    la tercera prueba de ME)
                                </strong>
                                , la{" "}
                                <strong>garantía comercial del 50 %</strong>
                                únicamente será aplicable cuando el aspirante no
                                haya podido acceder a la tercera prueba por no
                                haber superado alguna de las fases previas del
                                proceso selectivo. En consecuencia, la garantía
                                dejará de ser aplicable desde el momento en que
                                el aspirante sea convocado o participe en la
                                tercera prueba, incluyendo el{" "}
                                <strong>Biodata</strong>, la{" "}
                                <strong>entrevista personal</strong> o cualquier
                                actuación que forme parte de esta fase.
                            </p>
                        </Text>
                    </div>

                    {/** Devoluciones. Cancelación del Pedido e Incidencias - Certificados médicos y Exclusiones médicas */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Devoluciones. Cancelación del Pedido e Incidencias –
                            Certificados médicos y Exclusiones médicas
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                La reserva de citas para la obtención de
                                certificados médicos deberá realizarse
                                exclusivamente a través de la página web de
                                iOpos y mediante el correspondiente pago previo.
                                No será posible acudir directamente al centro
                                médico colaborador sin haber efectuado
                                previamente la reserva y el pago a través de los
                                canales habilitados por iOpos.
                            </p>

                            <p>
                                Las solicitudes de cambio de cita deberán
                                comunicarse obligatoriamente a través del correo
                                electrónico <strong>info@iopos.es</strong>. No
                                se aceptarán cambios o modificaciones
                                gestionados directamente con el centro médico.
                            </p>

                            <p>
                                Los servicios de gestión, reserva, emisión o
                                tramitación de certificados médicos ofrecidos
                                por iOpos tienen como finalidad facilitar al
                                usuario el acceso a centros médicos
                                colaboradores para la obtención de la
                                documentación exigida en determinados procesos
                                selectivos.
                            </p>

                            <p>
                                Los cambios de cita únicamente podrán realizarse
                                antes de la fecha y hora programadas para la
                                cita reservada. Una vez alcanzada la fecha u
                                hora de la cita, se considerará prestado el
                                servicio de reserva y no se admitirán cambios ni
                                reprogramaciones.
                            </p>

                            <p>
                                Las solicitudes de cancelación y devolución
                                deberán realizarse con un mínimo de{" "}
                                <strong>5 días naturales de antelación</strong>{" "}
                                respecto a la fecha de la cita programada.
                                Transcurrido dicho plazo, o en caso de no
                                asistencia a la cita reservada, no procederá la
                                devolución del importe abonado.
                            </p>

                            <p>
                                La no asistencia a la cita médica,
                                independientemente de la causa, no dará derecho
                                a devolución, compensación ni reprogramación de
                                la misma, salvo autorización expresa de iOpos.
                            </p>

                            <p>
                                La expedición del certificado médico corresponde
                                exclusivamente al profesional sanitario y al
                                centro médico que lo emite. iOpos actúa
                                únicamente como intermediario en la gestión de
                                la cita o reserva, sin intervenir en la
                                valoración médica, el contenido del certificado
                                ni el resultado de la exploración realizada.
                            </p>

                            <p>
                                Es responsabilidad exclusiva del interesado
                                revisar el certificado médico antes de abandonar
                                el centro, comprobando que los datos personales
                                consignados son correctos y completos,
                                incluyendo, entre otros, nombre y apellidos,
                                DNI/NIE, firma del facultativo, sello del centro
                                y cualquier otro requisito exigido por la
                                convocatoria correspondiente.
                            </p>

                            <p>
                                Asimismo, corresponde al comprador verificar
                                previamente los requisitos específicos exigidos
                                por la convocatoria a la que desea presentarse y
                                comprobar que el certificado emitido cumple con
                                dichos requisitos. iOpos no será responsable de
                                errores, omisiones, datos incorrectos,
                                incidencias detectadas con posterioridad a la
                                salida del centro médico o de la falta de
                                adecuación del certificado a las bases de una
                                convocatoria concreta.
                            </p>

                            <p>
                                La información relativa a cuadros médicos de
                                exclusión, requisitos de aptitud física o
                                condiciones sanitarias de acceso a procesos
                                selectivos tiene carácter meramente informativo.
                                La interpretación y aplicación de dichos
                                requisitos corresponde exclusivamente al
                                tribunal calificador, órgano convocante o
                                servicios médicos designados por la
                                administración competente.
                            </p>
                        </Text>
                    </div>

                    {/** Disputas y devoluciones a través de PayPal u otros medios de pago */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">
                            Disputas y devoluciones a través de PayPal u otros
                            medios de pago
                        </Title>
                        <Text className="space-y-2 text-justify">
                            <p>
                                En caso de que el usuario decida{" "}
                                <strong>
                                    abrir una disputa o solicitar una devolución
                                    directamente a través del proveedor de pagos
                                </strong>
                                utilizado para la compra, por ejemplo, PayPal u
                                otros medios de pago equivalentes,
                                <strong>
                                    la resolución del conflicto se someterá al
                                    procedimiento, plazos y criterios
                                    establecidos por dicho proveedor
                                </strong>
                                , y{" "}
                                <strong>
                                    no exclusivamente a la presente política
                                    interna de devoluciones
                                </strong>
                                .
                            </p>

                            <p>
                                Si como consecuencia de ese proceso se generasen{" "}
                                <strong>
                                    comisiones, gastos de gestión, tasas por
                                    disputa, penalizaciones o cualquier otro
                                    coste adicional para iOpos Academia
                                </strong>
                                , el usuario{" "}
                                <strong>autoriza expresamente</strong> a que
                                dichos importes puedan ser{" "}
                                <strong>
                                    descontados de la cantidad objeto de
                                    reembolso o compensación
                                </strong>
                                , o bien
                                <strong>
                                    reclamados al usuario cuando proceda
                                    conforme a la normativa aplicable
                                </strong>
                                .
                            </p>

                            <p>
                                Asimismo,{" "}
                                <strong>
                                    mientras la disputa, reclamación o proceso
                                    de devolución permanezca activo
                                </strong>
                                , iOpos podrá{" "}
                                <strong>
                                    suspender temporalmente el acceso del
                                    usuario a su cuenta, a los contenidos
                                    digitales, a los cursos, a los servicios
                                    contratados o a cualquier prestación
                                    vinculada a la compra afectada
                                </strong>
                                ,
                                <strong>
                                    hasta que el procedimiento quede resuelto de
                                    forma definitiva
                                </strong>
                                .
                            </p>
                        </Text>
                    </div>

                    {/** Atención al Cliente */}
                    <div className="privacidad mb-10">
                        <Title className="text-left">Atención al Cliente</Title>
                        <Text className="space-y-2 text-justify">
                            Si tienes cualquier consulta sobre su pedido o
                            necesita ayuda para completar el proceso de compra,
                            estamos a su disposición.
                            <br />
                            <br />
                            Para garantizar que puedas ser atendido ágil y
                            convenientemente, contáctanos, por favor,
                            escribiéndonos a{" "}
                            <a
                                href="mailto:info@iopos.academy"
                                className="link"
                            >
                                info@iopos.academy
                            </a>{" "}
                            o bien a través del WhatsApp{" "}
                            <a
                                href="https://wa.me/34644507478"
                                className="link"
                            >
                                644 507 478
                            </a>
                            ; como prefieras.
                            <br />
                            <br />
                            Aunque desde el Departamento de Atención al Cliente
                            de iOpos estamos a tu disposición para ayudarte,
                            atendiendo cualquier consulta o disconformidad que
                            quieras transmitirnos con respecto a tu compra, te
                            informamos de que la Comisión Europea ha habilitado
                            una plataforma -de resolución alternativa de
                            conflictos- a la que puedes acceder en el siguiente
                            enlace si estimas que, tras haber contactado con
                            nosotros, tu problema no se ha tramitado
                            convenientemente:{" "}
                            <a
                                target="_blank"
                                href="https://europa.eu/youreurope/business/dealing-with-customers/solving-disputes/online-dispute-resolution/index_es.htm"
                                rel="noopener noreferrer"
                                className="link"
                            >
                                Plataforma UE resolución alternativa
                            </a>
                            .
                        </Text>
                    </div>
                </div>
            </Layout>
        </>
    );
}
